// extracted by mini-css-extract-plugin
export default {"backContainer":"ALMBackButton_backContainer__Lq5o2","buttonLabel":"ALMBackButton_buttonLabel__npnqQ","backButton":"ALMBackButton_backButton__0GHU7"};